"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerStyle = exports.labelStyle = exports.formStyle = exports.popoverStyle = exports.iconStyles = exports.filterControlStyle = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../../utils/styleConsts");

var filterControlStyle = function filterControlStyle() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;display:inline-flex;vertical-align:middle;margin-left:7px;")
  );
};

exports.filterControlStyle = filterControlStyle;

var iconStyles = function iconStyles(theme, selected) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("fill:", theme.color.grey1, ";transform:scale(0.85);margin-top:-2px;", selected ? "\n    fill: ".concat(theme.color.black1, ";\n  ") : "\n    &:hover {\n      fill: ".concat(theme.color.accent, ";\n    }\n  "))
  );
};

exports.iconStyles = iconStyles;

var popoverStyle = function popoverStyle(theme, popupOnRight) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;top:22px;", popupOnRight ? 'left: -8px' : 'right: -8px;', "\n  z-index:1;min-width:180px;border-radius:5px;font-size:", _styleConsts.font.size.large, ";letter-spacing:normal;text-transform:none;background-color:", theme.color.white, ";box-shadow:0 12px 24px 0 rgba(34,47,66,0.1),0 1px 3px 0 rgba(34,47,66,0.15);")
  );
};

exports.popoverStyle = popoverStyle;

var formStyle = function formStyle() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flex-direction:column;")
  );
};

exports.formStyle = formStyle;

var labelStyle = function labelStyle() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin:15px 20px 0 20px;text-align:left;")
  );
};

exports.labelStyle = labelStyle;

var footerStyle = function footerStyle(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flex-direction:row;justify-content:flex-end;margin-top:15px;padding:10px;border-top:1px solid ", theme.color.grey2, ";button{margin-left:10px;}")
  );
};

exports.footerStyle = footerStyle;